import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaHome,
  FaUsers,
  FaWalking,
  FaClipboardList,
  FaBuilding,
  FaQuestionCircle,
} from "react-icons/fa";

const Sidebar = ({ screenName }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      {/* Toggle Button */}
      {/* <div className="toggle-btn" onClick={toggleSidebar}>
        <FaBars />
      </div> */}

      <ul className="nav-links">
        <li className={screenName === "dashboard" ? " active" : ""}>
          <Link to="/dashboard">
            <FaHome className="icon" />
            <span className="label">Dashboard</span>
          </Link>
        </li>

        <li className={screenName === "visits" ? " active" : ""}>
          <Link to="/visits">
            <FaWalking className="icon" />
            <span className="label">Visits & Inspections</span>
          </Link>
        </li>

        <li className={screenName === "schemes" ? " active" : ""}>
          <Link to="/schemes">
            <FaClipboardList className="icon" />
            <span className="label">Projects & Schemes</span>
          </Link>
        </li>

        <li className={screenName === "offices" ? " active" : ""}>
          <Link to="/offices">
            <FaBuilding className="icon" />
            <span className="label">Departments & Offices</span>
          </Link>
        </li>

        <li className={screenName === "users" ? " active" : ""}>
          <Link to="/users">
            <FaUsers className="icon" />
            <span className="label">Personnel & Inspectors</span>
          </Link>
        </li>

        <li className={screenName === "feedbackQuestions" ? " active" : ""}>
          <Link to="/feedback-questions">
            <FaQuestionCircle className="icon" />
            <span className="label">Feedback Questions</span>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
